var partial = require('./partial');
var before = require('./before');
exports = partial(before, 2);

module.exports = exports;
